export default __webpack_public_path__ + "static/media/HouseThree.e24293d9.jpg";